import {ItemStackContextType, useItemStackContext} from "./ItemStackContext";
import React from "react";
import {Button, ButtonTypes} from "../../react/components/ui/spectre/buttons";
import {Icon} from "../../react/components/ui/spectre/icon";

type Props = {
    onClick: (itemStack: ItemStackContextType) => void | Promise<void>,
}

export function FacilityIOButton({onClick}: Props) {
    const context = useItemStackContext();
    return <div className='text-right'>
        <Button buttonTypes={[ButtonTypes.primary]} onClick={() => onClick(context)}>
            <Icon type='plus'/>
        </Button>
    </div>;
}
